<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <div class="col-md-4 ml-auto mr-auto">
        <card class="card-login card-plain">
          <div slot="header">
            <div class="logo-container">
              <img src="img/logo1.png" alt="" />
            </div>
          </div>

          <div class="text-center">
            <fg-input
              v-if="!showPass"
              type="email"
              class="no-border form-control-lg txt_login"
              :placeholder="$t('app.modules.login.headers.email')"
              addon-left-icon="now-ui-icons ui-1_email-85"
              v-model="email"
              style="height: auto"
            >
            </fg-input>

            <fg-input
              v-if="showPass"
              type="password"
              class="no-border form-control-lg txt_login"
              :placeholder="$t('app.modules.login.headers.password')"
              addon-left-icon="now-ui-icons ui-1_lock-circle-open"
              v-model="password"
              style="height: auto"
            >
            </fg-input>
          </div>
          <div slot="footer">
            <n-button
              v-if="!showPass"
              @click.native="verifyEmail"
              type="primary"
              round
              block
            >
              {{ $t("app.modules.login.buttons.next") }}
            </n-button>
            <template v-else>
              <n-button @click.native="innerLogin" type="primary" round block>
                {{ $t("app.modules.login.buttons.log_on") }}
              </n-button>
              <n-button
                style="margin-top: 10px"
                @click.native="recoverPass"
                type="default"
                round
                block
              >
                {{ $t("app.modules.login.buttons.recovery") }}
              </n-button>
            </template>
          </div>
        </card>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import { mapState, mapMutations } from "vuex";
import Swal from "sweetalert2";
import { getResponse } from "@/util/utilities";
import * as Msal from "msal";
import ConstTiposUsuario from "@/models/FasesEntrega/ConstTiposUsuario";

extend("email", email);
extend("required", required);
extend("min", min);

export default {
  name: "login",
  computed: {
    ...mapState(["msalConf", "loginRequest"]),
  },
  data() {
    return {
      tiposUsuariosEnum: new ConstTiposUsuario(),
      email: "",
      password: "",
      credentials: { Alias: "", Contrasena: "" },
      showPass: false,
    };
  },
  methods: {
    ...mapMutations({
      setLoggedIn: "SET_LOGGED_IN",
      setLang: "SET_LANG",
      setUser: "SET_USER",
      setToken: "SET_TOKEN",
      //setRoles: "SET_ROLES",
      setRols: "SET_ROLS",
      //setModules: "SET_MODULES",
      setAvailableLangs: "SET_AVAILABLE_LANGS",
      //setPermissions: "SET_PERMISSIONS"
      setLoginDate: "SET_LOGIN_DATE",
    }),
    changeLanguage(value) {
      this.setLang(value);
      this.$root.$i18n.locale = value;
    },
    async verifyEmail() {
      Swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      let data = new FormData();
      data.append("email", this.email);
      data.append("externo", false);

      let request = await this.$http.post(
        route("Usuarios/verificarUsuario"),
        data
      );

      console.log("request -->" + JSON.stringify(request));

      let response = getResponse(request);

      if (response != null) {
        if (response.isAD) {
          this.msalConf.auth.clientId = response.clientId;
          this.msalConf.auth.authority =
            "https://login.microsoftonline.com/" + response.tenantId + "/";
          await this.loginAd();
        } else {
          this.showPass = true;
        }
      } else {
        if (request.body.code === 402) {
          this.notifyMessage(
            "danger",
            this.$t("app.modules.login.errors.invalid_user")
          );
        }

        if (request.body.code === 401) {
          this.notifyMessage(
            "danger",
            this.$t("app.modules.login.errors.invalid_email")
          );
        }
      }

      Swal.close();
    },
    async innerLogin() {
      Swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      this.credentials.Alias = this.email;
      this.credentials.Contrasena = this.password;

      let request = await this.$http.post(
        route("Usuarios/validateUserAdmin"),
        this.credentials
      );
      let response = getResponse(request);

      if (response != null) {
        await this.initUser(response.usuarios[0]);
      } else
        this.notifyMessage(
          "danger",
          this.$t("app.modules.login.errors.invalid_user")
        );

      Swal.close();
    },
    async loginAd() {
      const msalInstance = new Msal.UserAgentApplication(this.msalConf);

      let account = await msalInstance
        .ssoSilent({ loginHint: this.email })
        .catch(() => null);

      //popup
      if (account == null)
        account = await msalInstance.loginPopup().catch(() => null);
      //token
      if (account != null) {
        let accountToken = await msalInstance.acquireTokenSilent(
          this.loginRequest
        );

        if (accountToken != null) {
          let data = {
            token: accountToken.accessToken,
            uniqueId: accountToken.account.accountIdentifier,
            clientId: accountToken.account.idToken.aud,
            tenantId: accountToken.account.idToken.tid,
          };

          let request = await this.$http.post(
            route("Usuarios/validateUserAD"),
            data
          );
          let response = getResponse(request);

          if (response != null) {
            await this.initUser(response.usuarios[0]);
          } else
            this.notifyMessage(
              "danger",
              this.$t("app.modules.login.errors.invalid_user")
            );
        } else
          this.notifyMessage(
            "danger",
            this.$t("app.modules.login.errors.token_failed")
          );
      } else
        this.notifyMessage(
          "danger",
          this.$t("app.modules.login.errors.login_failed")
        );
    },
    async initUser(user) {
      this.credentials.Alias = "";
      this.credentials.Contrasena = "";
      this.setUser(user);
      this.setToken(user.token);
      //this.setRoles(user.roles);
      this.setRols(user.rols);
      //this.setModules(user.modulosRoles);
      //this.setPermissions(this.generatePermissions(user.modulosRoles));
      this.setLoggedIn(true);
      this.setLoginDate(new Date().toJSON().slice(0, 10).replace(/-/g, "/"));

      await this.$http
        .get(route("Idiomas/getIdiomas"))
        .then(
          async (_response) => {
            if (_response.body.code === 200) {
              this.setAvailableLangs(_response.body.idiomas);
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});

      switch (this.$store.state.user.accesoDatos) {
        case this.tiposUsuariosEnum.Administrativo:
          this.$router.push({ name: "Home" });
          break;
        //case this.tiposUsuariosEnum.Cliente: this.$router.push({ name: "Verificar permiso" }); break;
        //case this.tiposUsuariosEnum.Contacto: this.$router.push({ name: "Verificar permiso" }); break;
        case this.tiposUsuariosEnum.ServicioCliente:
          this.$router.push({ name: "Pedidos" });
          break;
        case this.tiposUsuariosEnum.Ventas:
          this.$router.push({ name: "Prospectos" });
          break;
        case this.tiposUsuariosEnum.Transportista:
          this.$router.push({ name: "Entregas" });
          break;
        case this.tiposUsuariosEnum.Logistica:
          this.$router.push({ name: "Entregas" });
          break;
        default:
          this.$router.push({ name: "Verificar permiso" });
      }
    },
    async recoverPass() {
      Swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      let request = await this.$http.post(
        route("Usuarios/passwordChangeRequest"),
        { email: this.email, origin: "Back" }
      );
      let response = getResponse(request);

      if (response != null) {
        this.notifyMessage(
          "success",
          this.$t("app.modules.login.success.request_sent")
        );
      } else
        this.notifyMessage(
          "danger",
          this.$t("app.modules.login.errors.request_failed")
        );

      Swal.close();
    },
  },
  mounted() {},
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
.section-image:after {
  background-color: rgba(0, 0, 0, 0) !important;
}
.full-page:after {
  background-color: rgba(0, 0, 0, 0) !important;
}
hr {
  border-top: 1px solid rgba(0, 0, 0, 0) !important;
}
.form-control {
  height: auto !important;
}
</style>
